export const messages = {
  en: {
    myAuditHistoryOrders: {
      title: 'Purchase History Orders',
      back: 'Back',
      refresh: 'Refresh',
      orderNumber: 'Order Number',
      orderType: 'Order Type',
      orderStatus: 'Order Status',
      applicant: 'Applicant',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View'
    }
  },
  zh: {
    myAuditHistoryOrders: {
      title: '采购已办单',
      back: '返回',
      refresh: '刷新',
      orderNumber: '订单号',
      orderType: '订单类型',
      orderStatus: '订单状态',
      applicant: '申请人',
      createTime: '创建时间',
      operation: '操作',
      view: '查看'
    }
  },
  'zh-TW': {
    myAuditHistoryOrders: {
      title: '採購已辦單',
      back: '返回',
      refresh: '刷新',
      orderNumber: '訂單號',
      orderType: '訂單類型',
      orderStatus: '訂單狀態',
      applicant: '申請人',
      createTime: '創建時間',
      operation: '操作',
      view: '查看'
    }
  }
}
